import React, { Component, Fragment } from 'react';
import './HeartButton.Module.scss';
import Modal from 'react-responsive-modal';
import {connect} from 'react-redux';
import { history } from 'components/App/components/UnauthenticatedApp';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeart as faHeartRegular,} from '@fortawesome/pro-regular-svg-icons';
import {faHeart as faHeartSolid,} from '@fortawesome/pro-solid-svg-icons';
import{ faTimes as faTimesLight} from '@fortawesome/pro-light-svg-icons';

import addFavorite from 'actions/favorite/add';
import removeFavorite from 'actions/favorite/remove';

const mapDispatchToProps = {
    addFavorite,
    removeFavorite
}


const mapStateToProps = (state, props) => {
    return {
        authentication: state.authentication,
        user: state.authentication.user
    };
};

class HeartButton extends Component {

    constructor() {
        super();
        this.state = {
            favorite: false,
        }
        this.toggle = this.toggle.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    toggle(e){
        e.stopPropagation();

        if(this.props.user.favorites.includes(this.props.id)) {
            this.props.removeFavorite(this.props.id);
        } else {
            this.props.addFavorite(this.props.id);
        }
    }
    
    openModal(e) {
        e.stopPropagation();
        this.setState({
            open: true,
        });
        
        window.scrollTo(0,0)
    }

    closeModal(e) {
        e.stopPropagation();
        this.setState({
            open: false
        });
        
        window.scrollTo(0,0)
    }

    render() {
        return (
        <Fragment>   
            <div onClick={this.props.authentication.isLoggedIn ? this.toggle : this.openModal} styleName='circle'>
                {this.props.user && this.props.user.favorites && this.props.user.favorites.includes(this.props.id) ?
                    <FontAwesomeIcon icon={faHeartSolid}/>
                    :
                    <FontAwesomeIcon icon={faHeartRegular}/>
                }
            </div>
            <Modal open={this.state.open} onClose={this.closeModal} styles={{
                modal: {
                padding:'0px',
                margin:'auto',
                backgroundColor:'transparent',
                WebkitBoxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0)',
                MozBoxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0)',
                boxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0.)',
                width: '100%',
                position: 'Static',
                marginTop:'40px',
                marginBottom:'40px',
                },
                closeButton:{
                    display:'none'
                },
                overlay:{
                    backgroundColor:'rgba(57, 59, 81, 0.8)',
                }
                }}>
                    <p styleName='cross5'
                        style={{position: 'absolute', fontSize: '25px', zIndex:'100', color:'white', right:'20px', top:'15px', cursor:'pointer',margin: '0px', height:'fit-content',lineHeight:'20px' }}
                    onClick={this.closeModal}><FontAwesomeIcon icon={faTimesLight}/></p>
                    <div styleName='modal'>
                        <FontAwesomeIcon icon={faHeartSolid}/>
                        <h1>Wil je deze functionaliteit gebruiken log dan in</h1>
                        <p>Door een account aan te maken kun je al je favoriete lessen van De Creatieve Code opslaan zodat je ze keer op keer weer kunt gebruiken.</p>
                        <div styleName='submit' onClick={(e)=> {
                            history.push('/inloggen') 
                            e.stopPropagation();
                        }}>Login pagina</div>
                    </div>
            </Modal>
        </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeartButton);
